import { useNavigate, useParams } from "react-router";
import { useContextoApp } from "@/app/contexto";
import { useApiResource } from "@/hooks/useApiResource";
import type { Cotizacion, RubroPresupuesto } from "@/lib/api";
import { filasComparacionItems } from "@/lib/presupuesto";

/**
 * Lógica de la ficha de un rubro del presupuesto (sin JSX): sólo para comparar ítem por ítem lo que cotizó cada
 * proveedor (las líneas de sus presupuestos vinculadas a los ítems) y ver los presupuestos recibidos con las
 * etiquetas del rubro. Los ítems y las etiquetas se editan en el rubro desplegado de Presupuesto (`useEdicionRubro`).
 * Ven admin y contador.
 */
export function usePresupuestoRubroTab() {
  const { fid } = useContextoApp();
  const { id } = useParams();
  const rubroId = Number(id);
  const navigate = useNavigate();
  const recurso = useApiResource<RubroPresupuesto>(Number.isInteger(rubroId) ? `/api/fideicomisos/${fid}/presupuesto/rubros/${rubroId}` : null);

  return {
    ficha: recurso.data ?? null,
    columnasComparacion: recurso.data?.comparacion_items.columnas ?? [],
    filasComparacion: recurso.data ? filasComparacionItems(recurso.data) : [],
    cargando: recurso.loading && !recurso.data,
    error: recurso.data ? null : (recurso.error?.message ?? null),
    abrirCotizacion: (c: Cotizacion) => navigate(`/cotizaciones/${c.id}`),
  };
}
